import React from "react";
import { Collapse, Grid, Switch, Typography } from "@mui/material";
import { UrlField } from "../urlField/urlField";
import FilledInput from "../forms/inputs/filledInput";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import Disclaimer from "../disclaimer";
import { EventType } from "modules/events";
import DialogField from "../dialogField";

import "./actionButtonInput.sass";

interface IActionButtonInputProps {
    isActive: boolean;
    buttonText: string;
    buttonLink: string;
    name: string;
    openLinkInNewWindow: boolean;
    eventType?: EventType;
    setButtonLink: (url: string) => void;
    setOpenInNewWindow: (open: boolean) => void;
    setButtonText: (text: string) => void;
    setIsActive: (isActive: boolean) => void;
}

export const ActionButtonInput: React.FC<IActionButtonInputProps> = ({
    isActive,
    buttonText,
    buttonLink,
    name,
    openLinkInNewWindow,
    eventType,
    setButtonLink,
    setOpenInNewWindow,
    setButtonText,
    setIsActive
}) => {
    const eventIsRSVP = eventType && eventType !== "informational";

    const textInput = <FilledInput
        refreshable
        value={buttonText}
        label={""}
        variant="outlined"
        inputProps={{
            placeholder: "Join here",
            style: {
                fontSize: '1rem'
            },
            onBlur: (e) => setButtonText(e.target.value),
        }}
        size="small"
        characterCount
        maxCount={20}
        inputContainerStyle={{ minHeight: 40, marginBottom: 0 }}
        style={{ minHeight: 40 }}
        inputLabelContainerStyle={{ display: 'none' }}
    />

    return <div>
        <div className="action-button-name-toggle">
            <Typography>{name}</Typography>
            <Switch
                color="primary"
                checked={isActive || eventIsRSVP}
                onChange={(_, checked) => setIsActive(checked)}
                disabled={eventIsRSVP}
            />
        </div>
        {
            eventIsRSVP &&
            <Disclaimer
                icon={<InfoOutlinedIcon />}
                text={`${eventType.charAt(0).toUpperCase() + eventType.slice(1)} RSVP events use 'RSVP Now' as the primary action button. This cannot be changed or removed.`}
                backgroundColor="#ffe9af"
            />
        }
        {
            <Collapse in={isActive && !eventIsRSVP}>
                <Grid
                    container
                    alignItems={"center"}
                    spacing={1}
                >
                    <DialogField
                        fieldLabelGridClassName="action-button-text-label"
                        fieldName="Text"
                        fieldInput={textInput}
                    />
                    <DialogField
                        fieldLabelGridClassName="action-button-link-label"
                        fieldName="Link"
                        fieldInput={
                            <UrlField
                                url={buttonLink}
                                openInNewWindow={openLinkInNewWindow}
                                setUrl={setButtonLink}
                                setOpenInNewWindow={setOpenInNewWindow}
                                placeholderText="Enter URL"
                            />
                        }
                    />
                </Grid>
            </Collapse>
        }
    </div>;
};
